import React from 'react';
import Modal from 'react-native-modal';
import { ScrollView, StyleSheet, useWindowDimensions } from 'react-native';
import { Button } from '@rneui/themed';
import { View } from './View';
import { useTheme } from '../../hooks';
import { useSnapPoints } from '../../hooks/player/useSnapPoints';
import { FAIcon } from './FAIcon';
export const ModalWindow = ({ isVisible, onCloseModal = () => { }, onBackButtonPress = onCloseModal, onBackdropPress = onCloseModal, children, style = {}, modalStyle = {}, containerStyle = {}, scrollable = true, center = false, ...rest }) => {
    const snapPoints = useSnapPoints();
    const { gutter, colors } = useTheme();
    const dims = useWindowDimensions();
    return (React.createElement(Modal, { isVisible: isVisible, onBackdropPress: onBackdropPress, onBackButtonPress: onBackButtonPress, deviceHeight: dims.height, deviceWidth: dims.width, style: modalStyle, ...rest },
        React.createElement(View, { style: StyleSheet.flatten([
                style,
                styles.containerStyle({
                    gutter,
                    snapPoints,
                    center,
                    backgroundColor: colors.backgroundPrimary,
                    shadowColor: colors.backgroundInverted,
                }),
            ]) },
            React.createElement(View, { style: styles.closeContainer(gutter) },
                React.createElement(Button, { onPress: onCloseModal, title: React.createElement(FAIcon, { name: 'times', size: gutter[2] }), buttonStyle: sheet.closeButton })),
            scrollable ?
                React.createElement(ScrollView, { style: [
                        { paddingHorizontal: gutter[2], width: '100%' },
                        containerStyle,
                    ] }, children)
                :
                    React.createElement(View, { style: StyleSheet.flatten([
                            {
                                backgroundColor: 'transparent',
                                paddingHorizontal: gutter[2],
                                width: '100%',
                            },
                            containerStyle,
                        ]) }, children))));
};
const sheet = StyleSheet.create({
    closeButton: {
        backgroundColor: 'transparent',
    },
});
const styles = {
    closeContainer: (gutter) => ({
        alignItems: 'flex-end',
        width: '100%',
        paddingHorizontal: gutter[2],
    }),
    containerStyle: ({ gutter, snapPoints, center, backgroundColor, shadowColor, }) => ({
        paddingTop: center ? snapPoints[1] / 5 : gutter[2],
        alignItems: center ? 'center' : 'stretch',
        paddingVertical: gutter[2],
        borderRadius: 15,
        backgroundColor,
        shadowColor,
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.4,
        shadowRadius: 8,
        elevation: 4,
    }),
};
//# sourceMappingURL=Modal.js.map